const ConfirmationWidget = ({ campaignInfo }) => {
  return (
    <div style={{ backgroundColor: 'transparent' }}>
  {/* Centered Container with Max Width */}
  <div className="container d-flex justify-content-center" style={{ maxWidth: '1400px' }}>
    <div className="row align-items-start w-100">
      
      {/* Left Text Section */}
      <div className="col-12 col-lg-5 me-auto mt-3 text-white" style={{ maxWidth: '500px' }}>
        <h1>Merci!</h1>
        <p className="fs-5">
        Heizen Sie effizienter und sparen Sie Energie mit einer Solaranlage und einer Wärmepumpe von AEW myHome. Berechnen Sie jetzt Ihre clevere Lösung und profitieren Sie von den attraktiven Förderbeiträgen.  
        </p>
        <input type="button" className="btn btn-primary" onClick={() => (window.location.href = "https://heizungsrechner.eturnity.io/aew_energie/" + campaignInfo.url)} value="Weiter zum Heizungsrechner »" />
        <br /><br />
        <input type="button" className="btn btn-primary" onClick={() => (window.location.href = "https://solarrechner.eturnity.io/aew_energie/" + campaignInfo.url)} value="Weiter zum Solarrechner »" />
      </div>
      
    </div>
  </div>
</div>

  );
  
}

export default ConfirmationWidget;
